import { Box, Heading, Text } from "src/components/UI";

type BulletNumberedImageCardProps = {
  title: string;
  description: string | React.JSX.Element;
  order: number;
  imageSrc: string;
};

const BulletNumberedImageCard = (props: BulletNumberedImageCardProps) => {
  const { title, description, order, imageSrc, ...restProps } = props;
  return (
    <Box
      justifyContent={["unset", "space-between"]}
      gap={["unset", "16px"]}
      {...restProps}
    >
      <Box
        flexDirection="row"
        padding={["16px"]}
        gap={["16px"]}
        alignItems={"flex-start"}
      >
        <Text
          fontSize={["14px"]}
          fontWeight={["700"]}
          lineHeight={["24px"]}
          letterSpacing={["0.16px"]}
          textAlign={["center"]}
          backgroundColor="#E11931"
          minWidth="24px"
          minHeight="24px"
          borderRadius="9999px"
          color="#fff"
        >
          {order}
        </Text>
        <Box alignSelf={["center"]}>
          <Heading
            fontFamily="Roboto, sans-serif"
            fontSize={["14px"]}
            fontWeight={["700"]}
            lineHeight={["20px"]}
            letterSpacing={["0.16px"]}
            textAlign={["left"]}
          >
            {title}
          </Heading>
          {description}
        </Box>
      </Box>
      <Box padding={["0 64px", "0"]} height={["unset", "386px"]}>
        <img
          src={imageSrc}
          style={{ width: "100%", height: "386px", objectFit: "contain" }}
        />
      </Box>
    </Box>
  );
};

export default BulletNumberedImageCard;
